/**
 * @generated SignedSource<<6506bb0d9d5d346938bca3d30cedb647>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuestionActions_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsClient" | "user_useIsGuest" | "user_useIsMember">;
  readonly " $fragmentType": "QuestionActions_User";
};
export type QuestionActions_User$key = {
  readonly " $data"?: QuestionActions_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionActions_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuestionActions_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsClient"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsMember"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "36de9bfe1fe3fb515c65b714e52c24df";

export default node;
